module.exports = __webpack_public_path__ + "static/security-analysis-sixth-edition-foreword-by-warren-buffett-f51bba011b6702e274ddb4e06b16a3a2.jpg";